module.exports = __webpack_public_path__ + "media/components/src/assets/images/dot/select-dec01a7efa1a53e46c8aeb4e3d6c8c52.svg";